import { ITavusPersonaFormik } from 'entities/tavus/persona';
import { FormikProps } from 'formik';
import { FC } from 'react';
import { Switch } from 'shared/ui';
import { ToolEvents } from './ToolEvents';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}

export const Tools: FC<IProps> = ({ formik }) => {
  return (
    <div className="ag-flex ag-flex-col ag-gap-y-5 ag-overflow-y-auto ag-h-full ag-max-h-full">
      <div className="ag-flex ag-items-start ag-justify-between ag-flex-row">
        <div className="ag-text-neutral-900 ag-flex ag-flex-col gap-y1">
          <span className="ag-font-semibold ag-flex ag-flex-col gap-y-1">
            Timer configuration(JSON)
          </span>
          <span className="ag-text-gray-muted">
            Set events to perform actions at specific time points.
          </span>
        </div>
        <div className="">
          <Switch
            onChange={(value) =>
              formik.setFieldValue('timer_config_enabled', value)
            }
            checked={Boolean(formik.values.timer_config_enabled)}
          />
        </div>
      </div>
      {formik.values.timer_config_enabled && <ToolEvents formik={formik} />}
    </div>
  );
};
